// extracted by mini-css-extract-plugin
export default {"page":"O0-z","cartModal":"P0-z","checkout":"Q0-z","placeholder":"R0-z","account":"S0-z"};